<script>
  import { fade } from "svelte/transition";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import Load from "../components/Load.svelte";

  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  $: if (settings) {
    if (settings.loggedin == true) {
      window.location.href = "./";
    }
  } else {
    settings = {
      url: "https://api.dekatan.com",
      loggedin: false,
    };
  }
  let alert = [];
  let shake = "shake";
  let email = "";

  let loading = false;
  async function handleSubmit(event) {
    loading = true;
    shake = "";
    axios
      .post(settings.url + "/auth/forget", {
        email: email,
      })
      .then(function (response) {
        nextStep();
      })
      .catch(function (error) {
        loading = false;
        email = "";
        shake = "shake";

        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: "Pastikan alamat Email anda sudah tepat & Aktif",
            color: "orange",
          },
        ];
      });
  }

  let step = 1;
  function nextStep() {
    loading = true;

    if (document.getElementsByClassName("tablist").length >= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step + 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
      loading = false;
    }
  }

  function backStep() {
    loading = true;
    if (document.getElementsByClassName("tablist").length <= step - 1) {
      document.getElementById("stepID" + step).className = "";
      document.getElementById("stepcontID" + step).style.display = "none";
      step = step - 1;
      document.getElementById("stepID" + step).className = "active";
      document.getElementById("stepcontID" + step).style.display = "block";
      loading = false;
    }
  }

  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }
</script>
<svelte:head>
<title>Pulihkan Akun - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<main
  transition:fade
  class="container flex justify-end px-2 pt-0 mx-auto mb-2 lg:pt-0 md:pt-16">
  {#if loading}
    <Load />
  {/if}
  <div class="shake {shake}">
    <div class="w-full mx-auto mt-24 lg:mt-5 md:w-2/4 lg:w-4/12">
      <div class="flex justify-center font-bold">
        <img
          on:click={() => redirect('/')}
          src="./assets/logo/logo.svg"
          width="274"
          height="64"
          alt="logo"
          class="h-16 cursor-pointer" />
      </div>
      <h2 class="mb-4 text-center text-gray-700 text-1xl">
        Pemulihan Lupa Password
      </h2>

      <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
        <div class="w-full mx-auto mb-2">
          <div class="block px-4 py-3 bg-white rounded-lg shadow-md group">
            <ul class="mt-5 mb-10 list-unstyled multi-steps tablist">
              <li role="presentation" id="stepID1" class="active">
                <span class="text-sm">Identify</span>
              </li>
              <li role="presentation" id="stepID2">
                <span class="text-sm">Verifikasi</span>
              </li>
            </ul>
            <div id="stepcontID1" class="block stepcontID">
              <form
                autocomplete="off"
                class="w-full"
                on:submit|preventDefault={handleSubmit}>
                <div class="px-2 pb-2">
                  <div class="w-full mb-2">
                    <div class="flex items-center">
                      <input
                        name="email"
                        autocomplete="off"
                        bind:value={email}
                        type="text"
                        id="email"
                        placeholder="Alamat Email"
                        class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded focus:outline-none" />
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="w-full px-5 py-2 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                    on:click={loadingBtn}
                    on:click={handleSubmit}>
                    PROSES
                  </button>
                </div>
              </form>

              <div class="mt-5 separator">atau</div>
              <p class="flex items-center justify-between my-2">
                <a
                  href="/daftar"
                  class="block w-full px-5 py-2 text-xs text-center text-blue-700 focus:outline-none"><span
                    class="text-gray-700">Belum Punya Akun ?</span>
                  <br />Daftar Baru</a>
                <a
                  href="/login"
                  class="block w-full px-5 py-2 text-xs text-center text-orange-700 focus:outline-none"><span
                    class="text-gray-700">Sudah Punya Akun ?</span>
                  <br />Login</a>
              </p>
            </div>
            <div id="stepcontID2" class="hidden stepcontID">
              <div
                class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
                <div class="w-full mx-auto mb-2">
                  <div
                    class="block p-5 py-10 bg-white rounded-lg shadow-md group">
                    <p class="text-center">
                      <b class="block mb-5 text-xl">Permohonan Kamu Sudah
                        Diproses!</b>
                      Silahkan kamu cek pesan konfirmasi yang kami kirim ke
                      alamat email berikut<br />
                      <b>{email}</b><br /><br />
                      Belum kunjung menerima email konfirmasi ?
                      <br />
                      <a
                        href="/forget"
                        on:click|preventDefault={() => backStep()}
                        class="block px-5 py-2 my-5 text-white bg-green-600 rounded">Kirim
                        Lagi</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<div class="flex justify-center max-w-screen-xl px-5 py-1 mx-auto items-bottom">
  <div
    class="w-full mt-4 text-sm font-light text-center text-gray-700 sm:py-2 sm:mt-0">
    <div>
      <span class="ml-1 text-gray-700">© 2021 Dekatan — PT. Rakit Solutions
        Indonesia</span>
    </div>
  </div>
</div>
